import Sortable from "sortablejs";

try {
    window.$ = window.jQuery = require('jquery');


    require('jquery-sticky');
    require('jquery-validation');
    require('shave/dist/jquery.shave');
    require('selectize');

    window.Flickity = require('flickity');

} catch (e) { console.log('EEEE')}

require('magnific-popup');
window.autosize =  require('autosize');
window.PhotoSwipe = require('photoswipe');
window.PhotoSwipeUI_Default = require('photoswipe/dist/photoswipe-ui-default');

//dropzone
window.Dropzone = require('dropzone');

//bootstrap
window.Sortable = require('sortablejs').Sortable;


//bootstrap
// window.shave = require('shave/dist/shave');

//scroller
import SimpleBar from 'simplebar'
window.SimpleBar = SimpleBar;


require('./header-scroll');
require('./main.js');
require('./news.js');
require('./mobi-menu.js');
require('./smallads.js');
require('./login.js');


require('./comments.js');
require('./comments-scroller.js');



require('./scroll-progress.js');













// WEBPACK FOOTER //
// ./Resources/assets/js/app.js